module.exports = __webpack_public_path__ + "media/images/icons/country_flags/tc-e2c8d6cb8b560ea109f21888cede9b9e.svg";